import * as React from 'react';
import { Box, StyledInput } from '../';
import { ErrorMessage, FieldProps } from 'formik';
import { Span, Label } from '../../typography';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import tag from 'blacklist-tag';
// import styled from 'styled-components';
// import { space, color } from 'styled-system';
// import { ThemeInterface } from '../../theme/ThemeInterface';
// import { theme } from '../../theme';
// import PlacesAutocomplete from 'react-places-autocomplete';
// import Loader from '../loaders/Loader';

type LocationSuggestorProps = FieldProps &
  StyledSystemProps & {
    label?: string;
    color?: string;
    placeholder?: string;
    type: string;
    disabled?: boolean;
    onInputChange?: (value: string) => void;
  };

// type HasSuggestion = {
//   hasSuggestions: boolean;
// };

// const DropdownCont = styled.div<StyledSystemProps & HasSuggestion>`
//   ${space};
//   ${color};
//   width: 100%;
//   border-top: 0;
//   align-items: center;
//   justify-content: center;
//   border-bottom-left-radius: 4px;
//   border-bottom-right-radius: 4px;
//   border: ${props => (props.hasSuggestions ? `1px solid ${theme.colors.paleGrey}` : 'none')};
// `;

// const DropdownItem = styled.div<StyledSystemProps>`
//   ${space};
//   ${color};
//   width: 100%;
//   display: flex;
//   flex-wrap: wrap;
//   box-sizing: border-box;
//   &:hover {
//     cursor: pointer;
//     background-color: ${(props: ThemeInterface) => props.theme.colors.paleGrey};
//   }
// `;

// TODO: Add unit tests
const LocationSuggestor: React.FC<LocationSuggestorProps> = ({ field, label, type, disabled, form, ...rest }) => {
  // const [address, setAddress] = React.useState(field.value || '');

  // function handleSelect(addressResult: string) {
  //   form.setFieldValue(field.name, addressResult);
  // }

  // function handleChange(value: string) {
  //   form.setFieldValue(field.name, value);
  //   setAddress(value);
  // }

  return (
    <Box {...rest}>
      <Label htmlFor={field.name}>{label}</Label>
      <StyledInput
        autoComplete="off"
        placeholder="Enter Address..."
        value={field.value}
        name={field.name}
        disabled={disabled}
        onChange={(e): any => {
          form.setFieldValue(field.name, e.target.value);
        }}
      />
      {/* <PlacesAutocomplete
        searchOptions={{
          componentRestrictions: {
            country: 'ZA',
          }
        }}
        value={address}
        onChange={handleChange}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <React.Fragment> */}
      <StyledInput
        // {...getInputProps({
        //   placeholder: 'Search Places...',
        // })}
        placeholder="Type address..."
        autoComplete="off"
        value={field.value}
        name={field.name}
        disabled={disabled}
        onChange={event => form.setFieldValue(field.name, event.target.value)}
      />
      {/* <DropdownCont hasSuggestions={suggestions && suggestions.length > 0}>
                {loading && <Loader width={20} height={20} />}
                {suggestions.map(suggestion => {
                  return (
                    <DropdownItem p={3} key={suggestion.id} {...getSuggestionItemProps(suggestion)}>
                      <Span pointer={true}>{suggestion.description}</Span>
                    </DropdownItem>
                  );
                })}
              </DropdownCont>
            </React.Fragment>
          );
        }}
      </PlacesAutocomplete> */}
      <ErrorMessage name={field.name}>
        {msg => (
          <Span mt={2} color="error" textAlign="right">
            {msg}
          </Span>
        )}
      </ErrorMessage>
    </Box>
  );
};

LocationSuggestor.defaultProps = {
  mb: 3,
  width: '100%',
  type: 'string',
  flex: 1,
  minWidth: '150px',
};

export const CleanLocationSuggestor = tag(LocationSuggestor, [
  'width',
  'display',
  'alignItems',
  'flexDirection',
  'justifyContent',
]);

export default CleanLocationSuggestor;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledLocationSuggestor.tsx